var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useBilling, useCard, useEmail, useShipping } from '../Providers';
import styled from 'styled-components';
export var Visible = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  opacity: ", ";\n  height: ", ";\n  overflow: ", ";\n  transition: opacity 0.3s ease-in;\n"], ["\n  opacity: ", ";\n  height: ", ";\n  overflow: ", ";\n  transition: opacity 0.3s ease-in;\n"])), function (p) { return (p.$visible ? 1 : 0); }, function (p) { return (p.$visible ? 'initial' : 0); }, function (p) { return (p.$visible ? 'visible' : 'hidden'); });
export var Unavailable = function (_a) {
    var until = _a.until, children = _a.children;
    var available = useIsAvailable(until);
    return _jsx(Visible, __assign({ "$visible": available }, { children: children }));
};
function useIsAvailable(until) {
    var emailCtx = useEmail();
    var shippingCtx = useShipping();
    var billingCtx = useBilling();
    var cardCtx = useCard();
    switch (until) {
        case '':
            return true;
        case 'ContactInfoComplete':
            return emailCtx.calledCompleted;
        case 'ShippingInfoComplete':
            return shippingCtx.calledCompleted;
        case 'PaymentInfoComplete':
            return billingCtx.calledCompleted;
        case 'BillingInfoComplete':
            return cardCtx.calledCompleted;
        default:
            return false;
    }
}
var templateObject_1;
//# sourceMappingURL=Visible.js.map